import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Appointments = () => {
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all'); // all, today, tomorrow, week

    // Mock data for appointments
    useEffect(() => {
        // Simulate loading appointment data
        setTimeout(() => {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);

            setAppointments([
                {
                    id: 1,
                    patientName: 'Maria Popescu',
                    doctorName: 'Dr. Ioan Dumitrescu',
                    date: today.toISOString().split('T')[0],
                    time: '09:00',
                    type: 'Consultație Generală',
                    status: 'confirmed',
                    notes: 'Control rutină'
                },
                {
                    id: 2,
                    patientName: 'Andrei Vasile',
                    doctorName: 'Dr. Elena Marinescu',
                    date: today.toISOString().split('T')[0],
                    time: '10:30',
                    type: 'Analize Sânge',
                    status: 'pending',
                    notes: 'Analize complete de sânge'
                },
                {
                    id: 3,
                    patientName: 'Ioana Radu',
                    doctorName: 'Dr. Mihai Constantinescu',
                    date: tomorrow.toISOString().split('T')[0],
                    time: '14:00',
                    type: 'Ultrasonografie',
                    status: 'confirmed',
                    notes: 'Ecografie abdominală'
                },
                {
                    id: 4,
                    patientName: 'George Matei',
                    doctorName: 'Dr. Ioan Dumitrescu',
                    date: today.toISOString().split('T')[0],
                    time: '15:45',
                    type: 'Consultație Specialist',
                    status: 'completed',
                    notes: 'Urmărire post-operatorie'
                }
            ]);
            setLoading(false);
        }, 1000);
    }, []);

    const getFilteredAppointments = () => {
        const today = new Date().toISOString().split('T')[0];
        const tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split('T')[0];

        switch (filter) {
            case 'today':
                return appointments.filter(apt => apt.date === today);
            case 'tomorrow':
                return appointments.filter(apt => apt.date === tomorrow);
            case 'week':
                const weekFromNow = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
                return appointments.filter(apt => apt.date <= weekFromNow);
            default:
                return appointments;
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'confirmed': return 'Confirmată';
            case 'pending': return 'În Așteptare';
            case 'completed': return 'Finalizată';
            case 'cancelled': return 'Anulată';
            default: return status;
        }
    };

    const getStatusClass = (status) => {
        switch (status) {
            case 'confirmed': return 'status-confirmed';
            case 'pending': return 'status-pending';
            case 'completed': return 'status-completed';
            case 'cancelled': return 'status-cancelled';
            default: return '';
        }
    };

    const filteredAppointments = getFilteredAppointments();

    return (
        <div className="appointments-page">
            <div className="page-navigation-header">
                <div className="nav-header-content">
                    <NavLink to="/dashboard" className="back-to-dashboard">
                        ← Înapoi la Dashboard
                    </NavLink>
                    <div className="quick-nav">
                        <NavLink to="/patients" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Pacienți
                        </NavLink>
                        <NavLink to="/doctors" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Doctori
                        </NavLink>
                        <NavLink to="/reports" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Rapoarte
                        </NavLink>
                    </div>
                </div>
            </div>

            <div className="page-header">
                <h1>Gestionare Programări</h1>
                <p>Vizualizați și gestionați toate programările medicale</p>
            </div>

            <div className="filters-section">
                <div className="filter-buttons">
                    <button
                        className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
                        onClick={() => setFilter('all')}
                    >
                        Toate Programările
                    </button>
                    <button
                        className={`filter-btn ${filter === 'today' ? 'active' : ''}`}
                        onClick={() => setFilter('today')}
                    >
                        Astăzi
                    </button>
                    <button
                        className={`filter-btn ${filter === 'tomorrow' ? 'active' : ''}`}
                        onClick={() => setFilter('tomorrow')}
                    >
                        Mâine
                    </button>
                    <button
                        className={`filter-btn ${filter === 'week' ? 'active' : ''}`}
                        onClick={() => setFilter('week')}
                    >
                        Săptămâna Aceasta
                    </button>
                </div>
                <button className="add-appointment-btn">Programare Nouă</button>
            </div>

            <div className="appointments-stats">
                <div className="stat-card">
                    <h3>Total Programări</h3>
                    <div className="stat-number">{filteredAppointments.length}</div>
                </div>
                <div className="stat-card">
                    <h3>Confirmate</h3>
                    <div className="stat-number">{filteredAppointments.filter(apt => apt.status === 'confirmed').length}</div>
                </div>
                <div className="stat-card">
                    <h3>În Așteptare</h3>
                    <div className="stat-number">{filteredAppointments.filter(apt => apt.status === 'pending').length}</div>
                </div>
                <div className="stat-card">
                    <h3>Finalizate</h3>
                    <div className="stat-number">{filteredAppointments.filter(apt => apt.status === 'completed').length}</div>
                </div>
            </div>

            <div className="appointments-list">
                {loading ? (
                    <div className="loading">Se încarcă lista programărilor...</div>
                ) : filteredAppointments.length === 0 ? (
                    <div className="no-appointments">Nu există programări pentru perioada selectată.</div>
                ) : (
                    <div className="appointments-grid">
                        {filteredAppointments.map(appointment => (
                            <div key={appointment.id} className="appointment-card">
                                <div className="appointment-header">
                                    <div className="appointment-time">
                                        <div className="date">{new Date(appointment.date).toLocaleDateString('ro-RO')}</div>
                                        <div className="time">{appointment.time}</div>
                                    </div>
                                    <div className={`appointment-status ${getStatusClass(appointment.status)}`}>
                                        {getStatusText(appointment.status)}
                                    </div>
                                </div>
                                <div className="appointment-details">
                                    <div className="patient-info">
                                        <h4>{appointment.patientName}</h4>
                                        <p>Tip: {appointment.type}</p>
                                    </div>
                                    <div className="doctor-info">
                                        <p><strong>Doctor:</strong> {appointment.doctorName}</p>
                                        {appointment.notes && (
                                            <p><strong>Note:</strong> {appointment.notes}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="appointment-actions">
                                    <button className="view-btn">Vezi Detalii</button>
                                    <button className="edit-btn">Editează</button>
                                    {appointment.status !== 'completed' && (
                                        <button className="cancel-btn">Anulează</button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <style jsx>{`
                .appointments-page {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 2rem;
                }

                .page-header {
                    margin-bottom: 2rem;
                }

                .page-header h1 {
                    color: #333;
                    margin-bottom: 0.5rem;
                }

                .page-header p {
                    color: #666;
                }

                .filters-section {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 2rem;
                    gap: 1rem;
                }

                .filter-buttons {
                    display: flex;
                    gap: 0.5rem;
                }

                .filter-btn {
                    padding: 0.5rem 1rem;
                    background: white;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    transition: all 0.3s;
                }

                .filter-btn:hover {
                    background: #f8f9fa;
                }

                .filter-btn.active {
                    background: #667eea;
                    color: white;
                    border-color: #667eea;
                }

                .add-appointment-btn {
                    padding: 0.75rem 1.5rem;
                    background: #667eea;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    transition: background 0.3s;
                }

                .add-appointment-btn:hover {
                    background: #5a67d8;
                }

                .appointments-stats {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 1rem;
                    margin-bottom: 2rem;
                }

                .stat-card {
                    background: white;
                    padding: 1.5rem;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    border-left: 4px solid #667eea;
                }

                .stat-card h3 {
                    margin: 0 0 0.5rem 0;
                    color: #666;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    font-weight: 600;
                }

                .stat-number {
                    font-size: 2rem;
                    font-weight: bold;
                    color: #333;
                }

                .loading, .no-appointments {
                    text-align: center;
                    padding: 3rem;
                    color: #666;
                }

                .appointments-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
                    gap: 1.5rem;
                }

                .appointment-card {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    padding: 1.5rem;
                    border-left: 4px solid #667eea;
                }

                .appointment-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 1rem;
                }

                .appointment-time .date {
                    font-weight: 600;
                    color: #333;
                }

                .appointment-time .time {
                    color: #667eea;
                    font-size: 1.1rem;
                    margin-top: 0.25rem;
                }

                .appointment-status {
                    padding: 0.25rem 0.75rem;
                    border-radius: 4px;
                    font-size: 0.8rem;
                    font-weight: 600;
                    text-transform: uppercase;
                }

                .status-confirmed {
                    background: #d4edda;
                    color: #155724;
                }

                .status-pending {
                    background: #fff3cd;
                    color: #856404;
                }

                .status-completed {
                    background: #d1ecf1;
                    color: #0c5460;
                }

                .status-cancelled {
                    background: #f8d7da;
                    color: #721c24;
                }

                .appointment-details {
                    margin-bottom: 1rem;
                }

                .patient-info h4 {
                    margin: 0 0 0.5rem 0;
                    color: #333;
                }

                .patient-info p {
                    margin: 0 0 0.5rem 0;
                    color: #666;
                }

                .doctor-info p {
                    margin: 0;
                    color: #666;
                    font-size: 0.9rem;
                }

                .appointment-actions {
                    display: flex;
                    gap: 0.5rem;
                }

                .view-btn,
                .edit-btn,
                .cancel-btn {
                    padding: 0.5rem 1rem;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    transition: background 0.3s;
                }

                .view-btn {
                    background: #28a745;
                    color: white;
                }

                .view-btn:hover {
                    background: #218838;
                }

                .edit-btn {
                    background: #ffc107;
                    color: #212529;
                }

                .edit-btn:hover {
                    background: #e0a800;
                }

                .cancel-btn {
                    background: #dc3545;
                    color: white;
                }

                .cancel-btn:hover {
                    background: #c82333;
                }

                .page-navigation-header {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-bottom: 2rem;
                    padding: 1rem;
                }

                .nav-header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 1rem;
                }

                .back-to-dashboard {
                    color: #667eea;
                    text-decoration: none;
                    font-weight: 500;
                    padding: 0.5rem 1rem;
                    border-radius: 4px;
                    transition: background 0.3s;
                }

                .back-to-dashboard:hover {
                    background: #f8f9fa;
                }

                .quick-nav {
                    display: flex;
                    gap: 1rem;
                }

                .quick-nav-link {
                    padding: 0.5rem 1rem;
                    color: #666;
                    text-decoration: none;
                    border-radius: 4px;
                    font-weight: 500;
                    transition: all 0.3s;
                }

                .quick-nav-link:hover, .quick-nav-link.active {
                    background: #667eea;
                    color: white;
                }

                .page-navigation-header {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-bottom: 2rem;
                    padding: 1rem;
                }

                .nav-header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 1rem;
                }

                .back-to-dashboard {
                    color: #667eea;
                    text-decoration: none;
                    font-weight: 500;
                    padding: 0.5rem 1rem;
                    border-radius: 4px;
                    transition: background 0.3s;
                }

                .back-to-dashboard:hover {
                    background: #f8f9fa;
                }

                .quick-nav {
                    display: flex;
                    gap: 1rem;
                }

                .quick-nav-link {
                    padding: 0.5rem 1rem;
                    color: #666;
                    text-decoration: none;
                    border-radius: 4px;
                    font-weight: 500;
                    transition: all 0.3s;
                }

                .quick-nav-link:hover, .quick-nav-link.active {
                    background: #667eea;
                    color: white;
                }

                @media (max-width: 768px) {
                    .filters-section {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .filter-buttons {
                        justify-content: center;
                        flex-wrap: wrap;
                    }

                    .appointments-grid {
                        grid-template-columns: 1fr;
                    }

                    .nav-header-content {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .quick-nav {
                        justify-content: center;
                    }
                }
            `}</style>
        </div>
    );
};

export default Appointments;
